import { Link } from "react-router-dom";
import { ArrowRight, FileText } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { pathFor } from "@/navConfig";
import { Reveal } from "@/components/Reveal";

export const CaseStudiesPromo = () => {
  const { t, lang } = useLanguage();
  const c = t.program.caseStudies;

  return (
    <section className="relative py-16 md:py-20 bg-[#01154F] border-y border-[#CEA26B]/25" data-testid="case-studies-promo">
      <div className="container-page">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">
            <div className="flex h-14 w-14 shrink-0 items-center justify-center border border-[#CEA26B]/50 text-[#CEA26B]">
              <FileText className="h-6 w-6" />
            </div>
            <div className="flex-1">
              <span className="overline text-[#CEA26B]">{c.overline}</span>
              <h2 className="mt-2 font-display font-bold tracking-tight text-white text-2xl sm:text-3xl leading-tight">
                {c.title}
              </h2>
              <p className="mt-3 text-base text-slate-400 leading-relaxed max-w-2xl">
                {c.promoText || c.subtitle}
              </p>
            </div>
            <Link
              to={pathFor("caseStudies", lang)}
              data-testid="case-studies-promo-btn"
              className="inline-flex shrink-0 items-center gap-2.5 bg-[#CEA26B] px-7 py-3.5 text-sm font-bold tracking-wide uppercase text-[#01154F] hover:bg-white transition-colors"
            >
              {c.promoBtn}
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
